import { Information } from '@oriola-corporation/kronan-icons';
import { Button, Modal, ModalRef } from '@oriola-corporation/ui-components';
import { useRef } from 'react';

export const Info = () => {
  const ref = useRef<ModalRef>(null);
  return (
    <div className="mb-4 bg-green-50 p-4 ">
      <div className="mb-2 flex items-center gap-2 text-center">
        <Information size={'35px'} className="text-green" />
        <h2 className=" text-xl font-bold">Returtjänsten</h2>{' '}
      </div>
      <p className="mb-3">
        Returtjänsten är inaktiverad tills Click & Collect Express har rullats ut till alla apotek.
        Hänvisa kunden till att skapa digital retursedel via QR-kod istället.
      </p>
      <p className="mb-3">
        Klicka på knappen nedan för att se instruktioner om hur ni vägleder kunden.
      </p>
      <Button variant="secondary" onClick={() => ref.current?.openModal()}>
        Visa instruktioner
      </Button>
      <Modal title="Lathund: Digital retursedel via QR-kod" id="lathund-modal" ref={ref}>
        <div className="space-y-6 p-6">
          <p className="text-lg font-medium">
            Så här vägleder ni kunden att genomföra en e-handelsretur
          </p>
          <div className="space-y-4">
            <div>
              <h3 className="mb-2 text-lg font-medium">Steg 1: Navigera till tacksidan</h3>
              <p className="mb-2">Kunden kan nå tacksidan på två sätt:</p>
              <ul className="ml-2 list-inside list-disc space-y-1">
                <li>
                  <span className="font-bold">Via bekräftelsemailet:</span> Klicka på knappen "Spåra
                  paket" i mailet
                </li>
                <li>
                  <span className="font-bold">Direkt via länk:</span>{' '}
                  <div className="flex flex-col gap-2">
                    <span className="rounded bg-gray-100 px-2 py-1 text-sm">
                      https://www.kronansapotek.se/order/&#123;ordernummer&#125;
                    </span>
                    <span className="ml-6 text-sm">
                      *Ersätt ordernummer med kundens ordernummer (K2-nummer)
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="mb-2 text-lg font-medium">Steg 2: Kontrollera returmöjlighet</h3>
              <ul className="ml-2 list-inside list-disc space-y-1">
                <li>Kunden scrollar ner till sektionen "Returnera varor"</li>
                <li>Kunden anger antingen telefonnummer eller e-postadress kopplat till ordern</li>
                <li>Om retur är möjlig visas knappen "Skapa digital retursedel"</li>
              </ul>
            </div>

            <div>
              <h3 className="mb-2 text-lg font-medium">Steg 3: Skapa retursedel</h3>
              <ul className="ml-2 list-inside list-disc space-y-1">
                <li>Kunden klickar på "Skapa digital retursedel"</li>
                <li>I vyn som öppnas kan kunden kryssa i de varor som är godkända för retur</li>
                <li>
                  För varje vara anger kunden:
                  <ul className="ml-6 mt-1 list-inside">
                    <li>Antal som ska returneras</li>
                    <li>Orsak till retur</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="mb-2 text-lg font-medium">Steg 4: Slutför och hämta QR-kod</h3>
              <ul className="ml-2 list-inside list-disc space-y-1">
                <li>Kunden klickar på "Skapa retursedel"</li>
                <li>En QR-kod genereras som kunden tar med till PostNord-ombud</li>
                <li>QR-koden kan antingen visas digitalt på mobilen eller skrivas ut</li>
              </ul>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
